<template>
  <div class="CartList-drugList" :class="checked ? 'CartList-drugList-active' : ''">
    <el-checkbox @change="onCheckboxClick" :value="checked"></el-checkbox>
    <div class="goods-img-wrap">
      <img
          @click="handlerItemDetailClick(gItem)"
          class="CartList-drugList-img pointer"
          v-if="gItem.itemThumbnail && gItem.itemThumbnail.includes('http')"
          :src="gItem.itemThumbnail + '?x-oss-process=image/resize,w_240/quality,q_90'"
          alt=""
      />
      <img
          @click="handlerItemDetailClick(gItem)"
          class="CartList-drugList-img pointer"
          v-else
          :src="require('@/assets/img/goods-empty.png')"
      />
      <img class="goods-label" :src="gItem.itemLabelIcon || (gItem.itemContent && gItem.itemContent.itemLabelIcon)" v-if="gItem.itemLabelIcon || (gItem.itemContent && gItem.itemContent.itemLabelIcon)" />
    </div>
    <div class="CartList-drugList-detail">
      <p @click="handlerItemDetailClick(gItem)" class="name pointer">{{ gItem.itemName }}</p>
      <p class="company">{{ gItem.itemContent.enterprise }}</p>
      <p v-if="isSpecial" class="sign">特价</p>
      <p v-if="isSpecial && !gItem.itemContent.havingAvailableCoupon" class="sign2">不可用券</p>
    </div>
    <span class="CartList-drugList-dose">{{ gItem.itemContent.spec }}</span>
    <div class="CartList-drugList-time">
      <p class="price">¥{{ price(gItem.sellingPrice) }}</p>
      <p v-if="isSpecial" class="price-origin">
        原价
        <span>¥{{ price(gItem.origPrice) }}</span>
      </p>
    </div>
    <div class="input-number-box">
      <el-input-number
        class="CartList-drugList-num"
        size="mini"
        v-model="num"
        :step="buyMultiple"
        :max="inputMax"
        :min="inputMin"
        :disabled="
          gItem.stockNumber < gItem.minBuyCount ||
            gItem.stockNumber < gItem.buyMultiple ||
            (gItem.remainLimitNumber > 0 && gItem.remainLimitNumber < gItem.buyMultiple)
        "
        @change="onStepperChange"
      />
      <div class="stock">
        <span
          v-if="
            gItem.stockNumber < gItem.minBuyCount || gItem.stockNumber < gItem.buyMultiple || gItem.stockNumber < num
          "
        >
          库存不足&nbsp;
        </span>
        <span
          v-if="
            gItem.remainLimitNumber > 0 &&
              (num > gItem.remainLimitNumber || gItem.remainLimitNumber < gItem.buyMultiple)
          "
        >
          限购
        </span>
        <span
          v-if="isSpecial && num >= gItem.remainLimitNumber && gItem.remainLimitNumber != -1"
          style="display: block; color: #D48806; margin-top: 8px"
        >
          特价商品已达限购数量
        </span>
      </div>
    </div>
    <span class="CartList-drugList-price CartList-money">¥{{ price(gItem.totalPrice) }}</span>
    <span @click="deleteItem" class="CartList-drugList-del pointer">删除</span>
  </div>
</template>
<script>
import { priceFenToYuan, throttle } from '@/helpers/utils';
import { cloneDeep, debounce } from 'lodash';
import * as api from '@/services';
export default {
  props: {
    gItem: {
      type: Object,
      default: () => ({})
    },
    shopId: {
      type: Number,
      default: () => ({})
    },
    isDisabled: {
      type: Boolean
    }
  },
  computed: {
    // specialOffer() {
    //   return this.gItem.itemContent?.itemLabel?.includes('specialOffer');
    // },
    isSpecial() {
      return this.gItem?.itemContent?.activityType === 'SPECIAL_PRICE'
    },
    checked() {
      return this.gItem.selected;
    }
  },
  data() {
    return {
      minBuyCount: 1, // 起购数
      maxBuyCount: 99999, // 最大限购数量
      stockNumber: 99999, // 库存
      buyMultiple: 1, // 购买倍数
      num: 1,
      cacheNum: 1,
      inputMax: 99999,
      inputMin: 1
    };
  },
  created() {
    this.num = this.gItem.num;
    this.minBuyCount = this.gItem.minBuyCount || 1;
    this.stockNumber = this.gItem.stockNumber || 99999;
    this.cacheNum = this.num;
    this.maxBuyCount =
      this.gItem.remainLimitNumber >= 0 ? Math.min(this.stockNumber, this.gItem.remainLimitNumber) : this.stockNumber;
    this.buyMultiple = this.gItem.buyMultiple || 1;
  },
  methods: {
    onStepperChange() {
      let copyNum = cloneDeep(Number(this.num));
      let maxBuyCount = this.maxBuyCount;
      if (maxBuyCount % this.buyMultiple !== 0) {
        const up = Math.floor(maxBuyCount / this.buyMultiple) * this.buyMultiple;
        maxBuyCount = up;
      }
      this.inputMax = maxBuyCount;
      let minBuyCount = this.minBuyCount;
      if (minBuyCount % this.buyMultiple !== 0) {
        const up = Math.ceil(minBuyCount / this.buyMultiple) * this.buyMultiple;
        minBuyCount = up;
      }
      this.inputMin = minBuyCount;
      let maxReson = this.maxBuyCount < this.stockNumber ? '您最多可购买' : '库存';

      if (copyNum < this.minBuyCount) {
        this.$message.warning(`最少${this.minBuyCount}${this.gItem.unit}起购`);
        copyNum = this.minBuyCount;
      } else if (copyNum > this.maxBuyCount) {
        if (maxReson === '库存') {
          this.$message.warning('库存不足，无法增加');
        } else {
          this.$message.warning(`${maxReson}${this.maxBuyCount}${this.gItem.unit}`);
        }
        copyNum = this.maxBuyCount;
      }
      if (copyNum % this.buyMultiple !== 0) {
        if (copyNum === this.minBuyCount) {
          const up = Math.ceil(copyNum / this.buyMultiple) * this.buyMultiple;
          copyNum = up;
        } else {
          const up = Math.ceil(copyNum / this.buyMultiple) * this.buyMultiple;
          const down = Math.floor(copyNum / this.buyMultiple) * this.buyMultiple;
          if (up <= this.maxBuyCount) {
            copyNum = up;
          } else {
            copyNum = down;
          }
        }
      }
      setTimeout(() => {
        this.num = copyNum;
        this.calculatePrice();
      }, 100);
    },
    price(val) {
      return priceFenToYuan(val);
    },
    handlerItemDetailClick(goods) {
      this.$router.push(`/goodsDetails/${goods.itemCode}`);
    },
    deleteItem() {
      this.$emit('deleteItem', [this.gItem.cartId]);
    },
    calculatePrice: debounce(function() {
      this.getTotalPrice();
    }, 500),
    async getTotalPrice() {
      const params = {
        itemCode: this.gItem.itemCode,
        number: this.num,
        shopId: this.shopId,
        callAddCartScene: 0,
        cartId: this.gItem.cartId
      };
      try {
        await api.cart.addOrUpdateCart(params);
        this.cacheNum = this.num;
        this.$emit('updateItem');
      } catch (error) {
        if (error.code === 'SHARE_ORDER-CART-ITEM_OVER_MAX_LIMIT') {
          this.num = this.cacheNum;
          this.getTotalPrice();
        }
      }
    },
    onCheckboxClick() {
      const { cartId } = this.gItem;
      this.$emit('checkboxClick', cartId);
    }
  }
};
</script>

<style lang="scss">
.CartList-drugList {
  font-size: 12px;
  display: flex;
  text-align: start;
  height: 113px;
  padding: 16px;
  border-bottom: 0.5px dashed #dfdfdf;
  ::v-deep .el-checkbox__input {
    vertical-align: top;
  }
  .goods-img-wrap {
    position: relative;
    margin-left: 15px;
  }
  .goods-label {
    position: absolute;
    top: 0;
    left: 0;
    height: 12px;
  }
  &-active {
    background: #eff7ff;
  }
  &-img {
    width: 80px;
    height: 80px;
  }
  &-detail {
    margin-left: 16px;
    width: 294px;
    .name {
      font-size: 12px;
      vertical-align: top;
      color: #333333;
      word-break: break-all;
      padding-right: 12px;
    }
    .company {
      font-size: 12px;
      margin-top: 8px;
      color: #888888;
    }
    .sign {
      display: inline-block;
      padding: 0px 4px;
      background: #ff8200;
      font-size: 12px;
      color: #ffffff;
      margin-top: 8px;
    }
    .sign2 {
      display: inline-block;
      background: #FFF7E6;
      border-radius: 1px;
      font-size: 10px;
      color: #FF8200;
      line-height: 10px;
      margin-left: 8px;
      padding: 2px 4px;
    }
  }
  &-dose {
    display: inline-block;
    width: 125px;
    font-size: 12px;
    color: #333333;
  }
  .input-number-box {
    .stock {
      text-align: center;
      margin-left: 56px;
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #d96900;
      line-height: 12px;
    }
  }
  &-time {
    width: 118px;
    .price {
      font-size: 12px;
      color: #333333;
      text-align: right;
    }
    .time {
      font-size: 12px;
      color: #888888;
      margin-top: 4px;
    }
    .price-origin {
      text-align: right;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 12px;
      margin-top: 4px;
      span {
        text-decoration: line-through;
      }
    }
  }
  &-price {
    color: #d96900;
    font-size: 18px;
    width: 134px;
    text-align: right;
    vertical-align: top;
    font-weight: 500;
  }
  &-del {
    width: 170px;
    text-align: right;
    padding-right: 42px;
    color: #888888;
    font-size: 12px;
  }
}
</style>
